<template>
  <div class="d-flex">
    <img
      :class="leftArrow !== leftArrowDisabled ? 'arrow-with-pointer' : ''"
      :src="leftArrow"
      alt="left-arrow"
      @click="goBack"
      @mouseover="leftHover(true)"
      @mouseleave="leftHover(false)"
    />
    <div class="card-navigation-counter">
      {{ current + 1 }} / {{ length }}
    </div>
    <img
      :class="rightArrow !== rightArrowDisabled ? 'arrow-with-pointer' : ''"
      :src="rightArrow"
      alt="right-arrow"
      @click="goForward"
      @mouseover="rightHover(true)"
      @mouseleave="rightHover(false)"
    />
  </div>
</template>

<script>
export default {
  name: 'CardNavigation',
  props: {
    length: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    }
  },
  watch: {
    length(newVal) {
      this.rightArrow = this.current === (newVal - 1)
        ? this.rightArrowDisabled
        : this.rightArrowDefault
    },
    current(newVal) {
      this.leftArrow = newVal === 0 ? this.leftArrowDisabled : this.leftArrowDefault
      this.rightArrow = newVal === (this.length - 1)
        ? this.rightArrowDisabled
        : this.rightArrowDefault
    }
  },
  data() {
    return {
      leftArrowDefault: '/images/arrows/left-default.svg',
      rightArrowDefault: '/images/arrows/right-default.svg',
      leftArrowActive: '/images/arrows/left-active.svg',
      rightArrowActive: '/images/arrows/right-active.svg',
      leftArrowDisabled: '/images/arrows/left-disabled.svg',
      rightArrowDisabled: '/images/arrows/right-disabled.svg',
      leftArrow: this.leftArrowDefault,
      rightArrow: this.rightArrowDefault
    }
  },
  created() {
    this.leftArrow = this.current === 0 ? this.leftArrowDisabled : this.leftArrowDefault
    this.rightArrow = this.current === (this.length - 1)
      ? this.rightArrowDisabled
      : this.rightArrowDefault
  },
  methods: {
    goBack() {
      this.$emit('back')
    },
    goForward() {
      this.$emit('forward')
    },
    rightHover(isHover) {
      if (this.rightArrow !== this.rightArrowDisabled) {
        this.rightArrow = isHover ? this.rightArrowActive : this.rightArrowDefault
      }
    },
    leftHover(isHover) {
      if (this.leftArrow !== this.leftArrowDisabled) {
        this.leftArrow = isHover ? this.leftArrowActive : this.leftArrowDefault
      }
    }
  }
}
</script>

<style scoped>
.arrow-with-pointer {
  cursor: pointer;
}
.card-navigation-counter {
  margin: 0 15px;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #4F4F4F;
}
</style>
